import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import _ from 'lodash';
import Qs from 'qs';
import { checkAuth } from '@/directive/auth';
import { toODataDate as apiToODataDate, odataDateToString as apiOdataDateToString } from './odata';
function getItemDefaultValue(schemaItem = {}) {
  const val = schemaItem.nullable;
  if (val === undefined || val === true) {
    return null;
  }
  return '';
}
/**
 * 根据schema定义生成指定初始化对象
 * @param {Object} schema
 * @returns
 */
export function getSchemaDefaultObject(schema = {}) {
  const ret = {};
  Object.keys(schema.properties).forEach(key => {
    ret[key] = getItemDefaultValue(schema.properties[key]);
  });
  return ret;
}
/**
 * 根据字符串数组取得对应的schema对象
 * @param {Object} schema
 * @param {Array} arr
 * @returns
 */
export function getSchemaByKeyArray(schema, arr) {
  const ret = {};
  if (schema && schema.properties && arr.length > 0) {
    arr.forEach(key => {
      if (typeof key === 'string') {
        const prop = schema.properties[key];
        if (prop === undefined) {
          console.log('当前使用的Schema为', schema);
          console.error('Schema内不存在设定的 {0} 的项目。');
        }
        if (prop) {
          ret[key] = prop;
        }
      } else {
        ret[key.key] = key;
      }
    });
  }
  return {
    properties: {
      ...ret
    }
  };
}
/**
 * 根据日期输出日期和时间（不同字段）
 * @param {Date} date
 * @returns
 */
export function getDateAndTime(dateObj) {
  const dateTime = new Date(dateObj);
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1 > 10 ? dateTime.getMonth() + 1 : '0' + (dateTime.getMonth() + 1);
  const day = dateTime.getDate() > 10 ? dateTime.getDate() : '0' + dateTime.getDate();
  const h = dateTime.getHours();
  const min = dateTime.getMinutes();
  const secode = dateTime.getSeconds() == 0 ? '00' : dateTime.getSeconds();
  return {
    day: year + '-' + month + '-' + day,
    hour: h + ':' + min + ':' + secode,
    date: year + '-' + month + '-' + day + ' ' + h + ':' + min + ':' + secode,
    LChgDate: year + '' + month + '' + day,
    LChgTime: h + '' + min + '' + secode
  };
}
export function mergeDomainsInSchema({
  properties
}, domains, mapList) {
  const schemaProperty = properties;
  Object.keys(domains).forEach(key => {
    if (mapList && mapList.length) {
      mapList.forEach(ele => {
        if (ele.domain === key && schemaProperty && schemaProperty[ele.property]) {
          schemaProperty[ele.property].oneOf = domains[ele.domain];
        }
      });
    } else {
      if (schemaProperty && schemaProperty[key]) {
        schemaProperty[key].oneOf = domains[key];
      }
    }
  });
  return schemaProperty;
}
/**
 * 修改schema中金额展示方式，只影响现实，不影响表单提交
 * 注意，此函数执行会对schema进行修改
 * @param {*} schema
 * @param {*} amountProps
 */
export function amountFormatInSchema({
  properties
}, amountProps) {
  const schemaProperty = properties || {};
  if (_.isArray(amountProps)) {
    amountProps.forEach(amountProp => {
      if (schemaProperty[amountProp]) {
        schemaProperty[amountProp].format = 'price';
        schemaProperty[amountProp].showFormat = true;
      }
    });
  }
}
/**
 * 根据formSchema生成初始化对象
 * @param formSchema 对象或数组
 * @param schema 完整schema对象
 * @returns {{}}
 */
export function getSchemaDefaultObjectByFormSchema(formSchema, schema) {
  let ret = {};
  if (formSchema) {
    if (_.isPlainObject(formSchema)) {
      ret = getSchemaDefaultObject(formSchema);
    } else if (_.isArray(formSchema)) {
      if (schema) {
        formSchema.forEach(key => {
          ret[key] = getItemDefaultValue(schema.properties[key]);
        });
      } else {
        formSchema.forEach(key => {
          ret[key] = '';
        });
      }
    }
  }
  return ret;
}
export function copyObjectByFromSchema(formSchema, src, schema) {
  const target = getSchemaDefaultObjectByFormSchema(formSchema, schema);
  Object.keys(target).forEach(key => {
    if (src[key] !== undefined) {
      target[key] = src[key];
    }
  });
  return target;
}
/**
 * 将一个带层级的数据列表转成树结构
 * @param {Array} array 带层级的数据列表
 * @param {Object} options 配置项 { key:节点键值, parentKey:父节点键值, children:数据存放属性 }
 */
// export function toArrayTree(array, options) {
//   return XEUtils.toArrayTree(array, options)
// }
/**
 * 将一个树结构转成数组列表
 * @param {Array} array 树结构
 * @param {Object} options 配置项 { children:子节点属性, data:数据存放属性, clear:同时移除子节点属性 }
 */
// export function toTreeArray(array, options) {
//   return XEUtils.toTreeArray(array, options)
// }
/**
 * 将一个树结构转成数组列表
 * @param {Array} array 树结构
 * @param {Object} options 配置项 { children:子节点属性, data:数据存放属性, clear:同时移除子节点属性 }
 */
// export function filterTree(array, iterate, options) {
//   return XEUtils.filterTree(array, iterate, options)
// }
/**
 * 从树结构中查找匹配第一条数据的键、值、路径
 */
// export function findTree(obj, iterate, options, context) {
//   return XEUtils.findTree(obj, iterate, options, context)
// }
/**
 * 从树结构中根据回调查找数据
 */
// export function searchTree(obj, iterate, options, context) {
//   return XEUtils.searchTree(obj, iterate, options, context)
// }
/**
 * 解析excel文件
 * @return 数据数组
 */
// export function parseExcelByFile(file, sheetNameArray, ignoreHeaderRow = true) {
//   return new Promise((resolve, reject) => {
//     const fileReader = new FileReader()
//     fileReader.onload = (ev) => {
//       const ret = []
//       try {
//         const data = ev.target.result
//         const workbook = xlsx.read(data, { type: 'binary' })
//         console.log(workbook)
//         const { Sheets } = workbook
//         sheetNameArray.forEach((sheetName) => {
//           const targetSheet = Sheets[sheetName]
//           const FS = '^%_&_&'
//           const RS = '__(_&)'
//           const csvData = xlsx.utils.sheet_to_csv(targetSheet, {
//             FS,
//             RS
//           })
//           const tableData = []
//           // 解析数据
//           csvData.split(RS).forEach((vRow, index) => {
//             if (!(ignoreHeaderRow && index === 0)) {
//               if (vRow) {
//                 tableData.push(vRow.split(FS))
//               }
//             }
//           })
//           ret.push(tableData)
//         })
//         console.log(ret)
//         resolve(ret)
//       } catch (err) {
//         reject(err)
//       }
//     }
//     fileReader.readAsBinaryString(file)
//   })
// }
/**
 * 将字符串形式的JavaScript日期转换为odata日期
 * @param {String} val 值
 * @param {String} format 格式
 * @returns String 格式为/Date(1614556800000)/
 */
export function toODataDate(val, format = 'YYYY-MM-DD') {
  return apiToODataDate(val, format);
}
/**
 * 将odata返回的日期转换为字符串形式的JavaScript日期
 * @param {String} val 值,格式为/Date(1614556800000)/
 * @param {String} format 格式化
 * @returns String
 */
export function odataDateToString(val = '', format = 'YYYY-MM-DD') {
  return apiOdataDateToString(val, format);
}
/**
 * 取得当前url的query参数对象
 * @param {*} top
 * @returns
 */
export function getUrlQueryObject(top) {
  let ret = {};
  const targetWin = top === false ? window : window.top;
  if (targetWin) {
    const {
      search
    } = targetWin.location;
    if (search && search.indexOf('?') === 0) {
      ret = Qs.parse(search.substring(1));
    }
  }
  return ret;
}
/**
 * 取得金额格式化实例
 * @param {*} config
 * @returns
 */
export function getNumberFormatter(config = {}) {
  return new Intl.NumberFormat('zh-CN', config);
}
/**
 * 转换为金额格式
 * @param {string | number} val
 */
export function priceFormatter(val, config) {
  const current = `${val}`;
  if (_.isEmpty(current)) {
    return val;
  }
  const format = v => {
    const ret = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return ret;
  };
  if (current.indexOf('.') !== -1) {
    const arr = current.split('.');
    arr[0] = format(arr[0]);
    return arr.join('.');
  }
  if (config && config.maximumFractionDigits > 0) {
    return `${format(current)}.${String(0).repeat(config.maximumFractionDigits)}`;
  }
  return format(current);
}
/**
 * 将字符串格式金额转换为数字格式
 * @param {string} val
 * @returns
 */
export function priceParser(val) {
  return val.replace(/(,*)/g, '');
}
// 获取最大层级
export const getMaxLevel = arr => {
  let maxLevel = 0;
  function multiArr(arr, level) {
    ++level;
    maxLevel = Math.max(level, maxLevel);
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      item.level = level;
      if (item.children && item.children.length > 0) {
        multiArr(item.children, level);
      } else {
        delete item.children;
      }
    }
  }
  multiArr(arr, 0);
  return maxLevel;
};
/**
 * 排序
 * @param {*} collection
 * @param {*} iteratees
 * @param {*} orders
 * @returns
 */
// export function orderBy(collection, iteratees, orders) {
//   return XEUtils.orderBy(collection, iteratees, orders)
// }
// 加法
export function accAdd(arg1, arg2) {
  arg1 = arg1 || 0;
  arg2 = arg2 || 0;
  let r1, r2, m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (Math.round(arg1 * m) + Math.round(arg2 * m)) / m;
}
// 减法
export function accSub(arg1, arg2) {
  arg1 = arg1 || 0;
  arg2 = arg2 || 0;
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
// 乘法
export function accMul(arg1, arg2) {
  arg1 = arg1 || 0;
  arg2 = arg2 || 0;
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {/**/}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {/**/}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}
// 除法
export function accDiv(arg1, arg2, precision = 6) {
  if (!arg1 || !arg2) {
    return null;
  }
  let t1 = 0;
  let t2 = 0;
  let r1;
  let r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
  } catch (e) {/**/}
  try {
    t2 = arg2.toString().split('.')[1].length;
  } catch (e) {/**/}
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  let result = r1 / r2 * Math.pow(10, t2 - t1);
  let power = Math.pow(10, precision);
  return String(Math.round(result * power) / power);
}
/*
寻找树形结构目标值
 * @param {Array} array
 * @param {key} string
 * @param {value} any
 * @returns
**/
export function getTargetInTreeData(array, key, value) {
  let o;
  if (array && array.length > 0) {
    array.some(function iter(a) {
      if (value?.includes(a[key])) {
        o = a;
        return true;
      }
      return Array.isArray(a.children) && a.children.some(iter);
    });
    return o;
  }
}
const env = process.env;
export function $authOperate(authId) {
  const hasPermission = checkAuth(authId);
  return hasPermission;
}
export function toHumpJsonString(obj) {
  function Camel(str) {
    str = str.toLowerCase().replace(/_(\w)/g, function (first, letter) {
      return letter.toUpperCase();
    });
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  if (obj instanceof Array) {
    obj.forEach(function (v, index) {
      toHumpJsonString(v);
    });
  } else if (obj instanceof Object) {
    Object.keys(obj).forEach(function (key) {
      const newKey = Camel(key);
      if (newKey !== key) {
        obj[newKey] = obj[key];
        delete obj[key];
      }
      toHumpJsonString(obj[newKey]);
    });
  }
  return obj;
}
export const priceFormat = val => {
  if (typeof val === 'string') {
    val.endsWith('-') && (val = '-' + parseInt(val));
  }
  if (!val || isNaN(val)) val = 0;
  const innerVal = Number(val).toFixed(2);
  return innerVal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export default {
  getSchemaDefaultObject,
  getSchemaByKeyArray,
  mergeDomainsInSchema,
  amountFormatInSchema,
  getSchemaDefaultObjectByFormSchema,
  copyObjectByFromSchema,
  toODataDate,
  odataDateToString,
  getUrlQueryObject,
  getNumberFormatter,
  priceFormatter,
  priceParser,
  getDateAndTime,
  getTargetInTreeData
};